import {DIRECTIVES} from './src/directives';
import {PROVIDERS} from './src/services';

export * from './src/directives';
export * from './src/services';

export default {
  directives: [DIRECTIVES],
  providers: [PROVIDERS]
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader?emitErrors=false&failOnHint=false!./angular2-embedly.ts
 **/